module.exports = __webpack_public_path__ + "assets/img/9@3x.8b02c90e.png";